<template>
	<div class="student-place-qcm-container">
		<FullPageLoader v-if="isLoading"/>
		<h1>{{ qcm.title }}</h1>
		<div class="remaining-time-container">
			<p class="timer">Temps restant <br> {{ timeLeft }}</p>
		</div>
		<div class="questions-container">
			<div class="question-container" v-for="question in qcm.questions" :key="question.id">
				<h2><span v-html="question.question" v-mathjax> </span> <span>({{question.point }} points)</span></h2>
				<QCMImage v-if="question.image" :image="question.image" />

				<div class="answers-container">
					<div class="answer" v-for="answer in question.answers_without_correct_answer" :key="answer.id">
						<label :for="answer.id">
							<input @change="checkIfThereIsTimeLeft()" v-model="selectedAnswers" :id="answer.id" type="checkbox" :value="getValue(question.id,answer.id)">
							<span v-html="answer.answer" v-mathjax></span>
						</label>
					</div>
				</div>
			</div>
		</div>
		<button class="submit dark" @click="submit()">Valider</button>
		<Teleport to="body">
			<PopUpShowImg :img="selectedQuestion.displayedImg" v-if="isPopUpImgVisible" @close="isPopUpImgVisible = false"/>
		</Teleport>
		<div v-if="isBlocked" class="blocked">
			<div class="unlock">
				<h2>Tu as quitté la fenêtre d’examen.</h2>
				<p>Tu es resté trop longtemps en dehors de la fenêtre d’examen.</p>
				<p>Par mesure de sécurité, ton examen a été suspendu et ton enseignant a été averti.</p>
				<form class="unlock__form" @submit.prevent="checkUnlock">
					<label>
						<div class="unlock__label">Pour reprendre l’épreuve, appelle ton enseignant pour qu'il débloque ta session.</div>
						<input
							class="unlock__input"
							type="password"
							v-model="unlockInput"
							placeholder="Entrez le code" />
					</label>
					<button type="submit" class="button button--primary">Débloquer</button>
					<p class="unlock__description">Appelle ton enseignant pour continuer.</p>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import Config from '../../config'
import {  authenticatedStudentApiFetch } from '../../utils/utils'
import { generateExamCode } from '../Utils/safeExam'
import FullPageLoader from '../Utils/FullPageLoader.vue'
import PopUpShowImg from '../PopUp/QCM/PopUpShowImg.vue'
import QCMImage from '../Admin/Resources/Resource/QCM/QCMImage.vue'
export default {
	components: { FullPageLoader, PopUpShowImg, QCMImage },
	data() {
		return {
			qcm:{},
			questions:[],
			answers:[],
			selectedAnswers: [],
			timeLeft: '10:00',
			isLoading: false,
			url: `${Config.backend_url}`,
			qcmStudentStartedAt: {},
			interval: null,
			alreadyDone: false,
			isPopUpImgVisible: false,
			selectedQuestion: null,
			isBlocked: false,
			endAt: null,
			pauseStart: null,
			pausedDuration: 0,
			unlockInput: '',
		}
	},
	computed: {
		examCode() {
			const { id } = this.$route.params;
			return generateExamCode(Number(id));
		}
	},
	methods: {
		showImg(selectedQuestion){
			this.selectedQuestion = selectedQuestion
			this.isPopUpImgVisible = true
		},
		async checkIfThereIsTimeLeft(){
			if(this.timeLeft === '0:0'){
				this.$store.state.toast = {
					status: 'error',
					text: 'Le temps est écoulé',
				}
				await this.submit()
				this.$router.push({name: 'StudentPlaceEvaluation'})
			}
		},
		getValue(questionId, answerId){
			return {questionId, answerId}
		},
		async submit(){
			
			this.isLoading = true
			this.checkIfAlreadyDoneQcm()
			for(const question of this.qcm.questions){
				const answersForQuestion = this.selectedAnswers.filter(x => x.questionId === question.id)
				const answers = answersForQuestion.map((answer)=>{
					return answer.answerId
				})
				const data = {
					qcm: this.qcm.id,
					question: question.id,
					answers: answers
				}

				try{
					await authenticatedStudentApiFetch(`/qcm-student-answers/`, {
						method: 'POST',
						body: JSON.stringify(data),
					})
				}
				catch(e){
					console.log(e)
				}
				
			}

			await this.calculateNote()
			this.isLoading = false
				

			this.$store.state.toast = {
				status: 'success',
				text: 'QCM validé',
			}

			this.$router.push({name: 'StudentPlaceEvaluation'})
		},

		async calculateNote(){
			const data = {
				qcm: this.qcm.id	
			}
			await axios.post(`${this.url}/qcm-student-notes-calculator`, data, {headers: {Authorization: `Student Bearer ${localStorage.getItem('studentToken')}`}})	
		},

		async getImg(question){
			const url = `${Config.backend_url}${question.image}`
			const res = await axios.get(url, {responseType: 'blob'})
			.then(blob => blob.data)

			return URL.createObjectURL(res)
		},

		async getQcm() {
			this.qcm = await authenticatedStudentApiFetch( `/qcm-students/${this.$route.params.id}/`, {method: 'GET'})
				.then(res =>res.json())
			
			for(const question of this.qcm.questions){
				if(question.image){
					question.displayedImg = await this.getImg(question)
				}
			}

			const res = await authenticatedStudentApiFetch(`/qcm-student-started-at/?qcm=${this.$route.params.id}`, {method: 'GET'})
				.then(res => res.json())

			this.qcmStudentStartedAt = res[0]

			if(!this.qcmStudentStartedAt){
				const data = {
					qcm: this.qcm.id
				}
				const res  = await authenticatedStudentApiFetch(`/qcm-student-started-at/`, {
					method: 'POST',
					body: JSON.stringify(data)
				})
				.then(res => res.json())
				this.qcmStudentStartedAt = res
			}
		},
		addMinutes(date, minutes) {
			const dateCopy = new Date(date);
			dateCopy.setMinutes(date.getMinutes() + minutes);  
			return dateCopy;
		},
		
		startTimer(){
			const startedAt = new Date(this.qcmStudentStartedAt.started_at)
			this.endAt = this.addMinutes(startedAt, this.qcm.duration)
			this.pauseStart = null
			this.pausedDuration = 0
			this._launchInterval()

		},
		_launchInterval() {
			clearInterval(this.interval)
			this.interval = setInterval(() => {
				if (this.isBlocked) return
				const now = new Date()
				const diff = this.endAt - now
				const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
				const seconds = Math.floor((diff % (1000 * 60)) / 1000)
				this.timeLeft = seconds < 10
							? `${minutes}:0${seconds}`
							: `${minutes}:${seconds}`
				if (diff < 0) {
					clearInterval(this.interval)
					this.timeLeft = '0:0'
					
					this.submit()
				}
			}, 1000)

		},
		async checkIfAlreadyDoneQcm(){
			const res = await authenticatedStudentApiFetch(`/qcm-student-answers/?qcm=${this.$route.params.id}`, {method: 'GET'})
				.then(res => res.json())
				
			if(res.results.length > 0){
				this.alreadyDone = true
				this.$store.state.toast = {
					status: 'error',
					text: 'Vous avez déjà répondu à ce QCM',
				}
				this.$router.push({name: 'StudentPlaceEvaluation'})
			}
		},

		onCheatDetected() {
			if (this.isBlocked) return;
			this.isBlocked = true;
			clearInterval(this.interval);
			this.pauseStart = new Date();
			localStorage.setItem(`qcm-blocked-${this.qcm.id}`, 'true');
		},

		handleVisibilityChange() {
			if (document.hidden) {
				this.onCheatDetected()
			}
		},

		onResume() {
			this.isLoading = false;
			const now = new Date();
			const pause = now - this.pauseStart;
			this.pausedDuration += pause;
			this.endAt = new Date(this.endAt.getTime() + pause);
			this.pauseStart = null;
			this.isBlocked = false;
			localStorage.removeItem(`qcm-blocked-${this.qcm.id}`);
			this._launchInterval()
		},

		checkUnlock() {
			if (this.unlockInput === this.examCode) {
				this.unlockInput = '';
				this.$store.state.toast = {
					status: 'success',
					text: 'Code validé',
				}
				this.onResume();
				localStorage.removeItem(`qcm-blocked-${this.qcm.id}`);
				this.isBlocked = false;
			} else {
				this.$store.state.toast = {
					status: 'error',
					text: 'Code incorrect',
				}
			}
		}
	},
	async created() {
		this.isLoading = true;
		await this.checkIfAlreadyDoneQcm();
		if (this.alreadyDone) {
			this.isLoading = false;
			return;
		}

		await this.getQcm();
		this.startTimer();

		document.addEventListener('mouseleave', this.onCheatDetected);
		window.addEventListener('blur',          this.onCheatDetected);
		document.addEventListener('visibilitychange', this.handleVisibilityChange);

		const blockedKey = `qcm-blocked-${this.$route.params.id}`;
		if (localStorage.getItem(blockedKey) === 'true') {
			this.onCheatDetected();
		}
		this.isLoading = false;
	},
	beforeUnmount() {
		clearInterval(this.interval)
		document.removeEventListener('mouseleave', this.onCheatDetected);
		window.removeEventListener('blur', this.onCheatDetected);
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
	}	
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/student-place/qcm.scss';
</style>
